import { Dialog, DialogProps, ModalHeader } from "@/components/modal";
import ViewCajaActualAperturaHistorial from "@/features/cajas/caja-actual/components/view-caja-actual-apertura-historial";

export default function ViewCajaActualHistorialModal({
    ...props
}: DialogProps) {
    return <Dialog size="lg" fullHeight {...props}>
        <ModalHeader>Historial de Arqueo</ModalHeader>
        <ViewCajaActualAperturaHistorial padding={3} flex={1} />
    </Dialog>
}